import React, { useState } from 'react';
import PropTypes from 'prop-types';
import app from 'new-ui/app';
import { INTERCOM_EVENTS } from 'modules/intercom/intercom';
import { getBiomarkers } from 'modules/user/utils';
import { BiomarkersNotFound } from './BiomarkersNotFound';
import { UploadForm } from './UploadForm';

export const UploadFlow = ({
  condition,
  onSuccess = () => {},
  onUpdate,
  onBeforeIntake,
  onUploadFiles,
  onUploadedFilesChange,
  onGotoResultsAction,
  presentNgsNotFound = false,
}) => {
  const [uploadData, setUploadData] = useState(null);
  const [showNgsNotFound, setShowNgsNotFound] = useState(false);

  const removeCloseIcon = () => {
    const icon = document.querySelector('.popup-theme-middle .popup-header img');
    if (icon) {
      icon.classList.add('hidden');
    }
  };

  const handleUploadClick = () => {
    setShowNgsNotFound(false);
    (onUpdate ?? onSuccess)(uploadData.user, uploadData.questions);
  };

  const handleNotNowClick = () => {
    app.closePopups();
    onSuccess(uploadData.user, uploadData.questions);
  };

  const handleUploadForm = (shouldClosePopupOnUpdate) => ({ user }, questions) => {
    // in the case of onUpdate questions is undefined
    if (!presentNgsNotFound) {
      if (shouldClosePopupOnUpdate) {
        app.closePopups();
      }
      onSuccess(user, questions);
      return;
    }

    if (!getBiomarkers(user)?.length) {
      app.intercom.sendEvent(INTERCOM_EVENTS.NGS.BIOMARKERS_NOT_EXTRACTED);
      removeCloseIcon();
      setUploadData({ user, questions });
      setShowNgsNotFound(true);
      return;
    }

    if (shouldClosePopupOnUpdate) {
      app.closePopups();
    }
    onSuccess(user, questions);
  };

  if (presentNgsNotFound && showNgsNotFound) {
    return (
      <BiomarkersNotFound
        onUploadClick={handleUploadClick}
        onNotNowClick={handleNotNowClick}
      />
    );
  }

  return (
    <UploadForm
      condition={condition}
      onSuccess={handleUploadForm(true)}
      onUpdate={handleUploadForm(false)}
      onBeforeIntake={onBeforeIntake}
      uploadFiles={onUploadFiles}
      onUploadedFilesChange={onUploadedFilesChange}
      onGotoResultsAction={onGotoResultsAction}
    />
  );
};

UploadFlow.propTypes = {
  condition: PropTypes.string,
  onSuccess: PropTypes.func,
  onUpdate: PropTypes.func,
  onBeforeIntake: PropTypes.func,
  onUploadFiles: PropTypes.func.isRequired,
  onUploadedFilesChange: PropTypes.func.isRequired,
  onGotoResultsAction: PropTypes.func,
  presentNgsNotFound: PropTypes.bool,
};
